export default __webpack_public_path__ + "static/media/logicImmoNeuf.12eaeb5f.svg";